import { AffiliateConstants } from "./IAffiliate";
import { ContentType } from "./IContent";
import { AvailableCurrencies, AvailableLanguages } from "./IGenerics";
import { OfferConstants } from "./IOffer";

export namespace ProductConstants {
  export enum Type {
    FILES = "FILES",
    SERVICE = "SERVICE",
    COURSE = "COURSE",
  }

  export enum Slug {
    FILES = "file",
    SERVICE = "service",
    COURSE = "community",
  }

  export const TypeOptions = [
    {
      name: Type.FILES,
      value: Slug.FILES,
      label: "E-book e arquivos",
    },
    {
      name: Type.SERVICE,
      value: Slug.SERVICE,
      label: "Serviço",
    },
    {
      name: Type.COURSE,
      value: Slug.COURSE,
      label: "Curso",
    },
  ];

  export enum Status {
    INCOMPLETE = "INCOMPLETE",
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    REFUSED = "REFUSED",
  }

  export const StatusOptions = [
    {
      value: Status.INCOMPLETE,
      label: "Incompleto",
    },
    {
      value: Status.ACTIVE,
      label: "Ativo",
    },
    {
      value: Status.INACTIVE,
      label: "Inativo",
    },
    {
      value: Status.REFUSED,
      label: "Recusado",
    },
  ];

  export enum ContactValidationTypes {
    SEND = "SEND",
    CONFIRM = "CONFIRM",
  }

  export enum ContactTypes {
    EMAIL = "EMAIL",
    PHONE = "PHONE",
  }

  export enum CommunityTypes {
    KIRVANO = "KIRVANO",
    EXTERNAL = "EXTERNAL",
  }
}

export type ProductType = {
  uuid: string;
  userUuid: string;
  user?: { uuid: string; name?: string };
  companyUuid: string;
  company?: { uuid: string; name?: string };
  courseUuid: string;
  categoryUuid: string;
  category?: { uuid: string; name?: string };
  formatUuid: string;
  format?: { uuid: string; name?: string };
  currency: AvailableCurrencies;
  language: AvailableLanguages;
  status: ProductConstants.Status;
  name: string;
  sellerName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  description?: string | null;
  photo?: string | null;
  isPublishable: boolean;
  issues: Record<string, string>;
  salesCount: number;
  salesIncome: number;
  createdAt: Date;
  updatedAt: Date;
  contents?: ContentType[];
};

export type ProductValidateContactType = {
  validationType: ProductConstants.ContactValidationTypes;
  contactType: ProductConstants.ContactTypes;
  contact: string;
  productUuid: string;
  uuid?: string | null;
  code: string;
};

export type ProductContactType = {
  uuid: string | null;
  contact: string | null;
  required: boolean;
  valid: boolean;
  block: boolean;
};

export enum ProductionRole {
  COPRODUCER = "coproducer",
  AFFILIATE = "affiliate",
  PRODUCER = "producer",
}
export interface useFetchProductsProps {
  params?: {
    page: number;
    pageSize: number;
    status?: string[];
    format?: ProductConstants.Slug[];
    productionRole?: ProductionRole[];
    search: string;
  };
}

export type ListProductsResponseType = {
  meta: {
    page: number;
    pages: number;
    pageSize: number;
    total: number;
  };
  data: ListProductType[];
};

export type ListProductType = {
  uuid: string;
  categoryUuid: string;
  category?: { uuid: string; name?: string };
  formatUuid: string;
  format?: { uuid: string; name?: string };
  name: string;
  producer?: string;
  url?: string;
  currency: AvailableCurrencies;
  language: AvailableLanguages;
  status: ProductConstants.Status;
  description?: string | null;
  photo?: string | null;
  salesCount: number;
  salesIncome: number;
  createdAt: Date;
  updatedAt: Date;
  isAffiliate: boolean;
  affiliateStatus: AffiliateConstants.Status;
  affiliateUuid?: string;
};

export type ShowProductType = {
  uuid: string;
  userUuid: string;
  user?: { uuid: string; name?: string };
  companyUuid: string;
  company?: { uuid: string; name?: string };
  courseUuid: string;
  categoryUuid: string;
  category?: { uuid: string; name?: string };
  formatUuid: string;
  format?: { uuid: string; name?: string };
  currency: AvailableCurrencies;
  language: AvailableLanguages;
  status: ProductConstants.Status;
  name: string;
  sellerName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  description?: string | null;
  photo?: string | null;
  isPublishable: boolean;
  affiliatesEnabled: boolean;
  issues: Record<string, string>;
  salesCount: number;
  salesIncome: number;
  landingPageUrl?: string;
  createdAt: Date;
  updatedAt: Date;
  contents?: any[];
  isAffiliate: boolean;
  communityType: ProductConstants.CommunityTypes;
};

export type ProductRefusedReasonType = {
  uuid: string;
  evaluationRefusedReason?: string;
};

export type ProductRefusedReasonResponseType = {
  data: ProductRefusedReasonType;
};

export type CreateProductRequestType = {
  userUuid: string;
  companyUuid: string;
  categoryUuid: string;
  formatUuid: string;
  copyFromProductUuid?: string;
  status?: ProductConstants.Status;
  name: string;
  description?: string;
  language: AvailableLanguages;
  currency: AvailableCurrencies;
  coverPicture?: string;
  landingPageUrl: string;
  evaluationDescription: string;
  evaluationHasLoginPass?: boolean;
  evaluationLogin?: string | null;
  evaluationPassword?: string | null;
  evaluationHasAcceptedTerms?: boolean;
  communityType?: ProductConstants.CommunityTypes;
};

export type ListPublishableProductsResponseType = {
  meta: {
    page: number;
    pages: number;
    pageSize: number;
    total: number;
  };
  data: ListPublishableProductsType[];
};

export type ListProductsSoldResponseType = {
  data: ListProductsSoldType[];
};

export type ListProductsSoldType = {
  id: string;
  uuid: string;
  name: string;
};

export type AvailableOfferDataType = {
  uuid: string;
  name: string;
  billingType: OfferConstants.BillingType;
  price: number;
};

export type ListPublishableProductsType = {
  uuid: string;
  name: string;
  currency: AvailableCurrencies;
  language: AvailableLanguages;
  offers: AvailableOfferDataType[];
};

export interface ContactValidationCodeRequestType {
  userUuid: string;
  productUuid: string;
  contactType: ProductConstants.ContactTypes;
  contact: string;
}

export interface ConfirmContactValidationCodeRequestType {
  uuid: string;
  userUuid: string;
  productUuid: string;
  code: string;
}

export interface ProductsFiltersType {
  type?: ProductConstants.Slug[];
  status?: string[];
}
